export class DetIncBotones{
   

    public titulo: String;
    public icono: String;

    constructor(
        titulo: String,
        icono: String
      ) {
        this.titulo = titulo;
        this.icono = icono;
      }

}